import { KINDS, isZone, isLiteral, isDelimiter, isRowBreak, zoneCapacity } from '../Formative/dropZones';

export const MAX_POOL_ITEMS = 10;
export const POOL_SINGLE_ROW_LIMIT = 4;
export const TRACK_DENSE_ENTRIES = 8;
export const TRACK_TIGHT_ENTRIES = 10;

export { KINDS, isZone, isLiteral, isDelimiter, isRowBreak, zoneCapacity };

export const LOG =
  process.env.NODE_ENV !== 'production'
    ? (...args) => console.log('[SEQUENCING]', ...args)
    : () => {};

export function trackZones(dropZones) {
  return (dropZones || []).filter(isZone);
}

export function splitPoolIntoRows(pool) {
  const items = pool || [];
  if (items.length === 0) return [];
  if (items.length <= POOL_SINGLE_ROW_LIMIT) return [items];
  const topRowCount = Math.ceil(items.length / 2);
  return [items.slice(0, topRowCount), items.slice(topRowCount)];
}

export function encodePlacements(zones, placements) {
  return JSON.stringify((zones || []).map((_zone, index) => (placements || [])[index] ?? null));
}

export function trackDensity(entryCount) {
  if (entryCount >= TRACK_TIGHT_ENTRIES) return 'tight';
  if (entryCount >= TRACK_DENSE_ENTRIES) return 'dense';
  return 'roomy';
}
